/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class SchemaPropertyService extends services.DataService<Wars.Domain.Model.SchemaProperty> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public getSchemaProperty(id: string): ng.IPromise<Wars.Domain.Model.SchemaProperty> {
            return this.fetchById(id, "SchemaProperty");
        }

        public getSchemaPropertyByUniqueId(id: string): ng.IPromise<Wars.Domain.Model.SchemaProperty> {
            var d = this.$q.defer();
            const query = this.breezeModule.EntityQuery
                .from("SchemaProperties")
                .where('uniqueIdentifier', '==', id);

            this.executeQuery(query).then(r => {
                //TODO: Change this to work with the current SchemaProperty
                d.resolve(r[0]);
            });

            return d.promise;
        }

        public createNewSchemaProperty(): models.SchemaProperty {
            var newSchemaProperty = this.createNewEntity<models.SchemaProperty>("SchemaProperty");
            newSchemaProperty.isIndexed = false;
            newSchemaProperty.required = false;
            newSchemaProperty.isSystemLevel = false;
            newSchemaProperty.uniqueIdentifier = services.UtilityService.generateGuidComb();
            return newSchemaProperty;
        }
    }
}

warsApp.registerService('SchemaPropertyService', ['breeze', '$q']);